export const MAP_SETTINGS_PROXIMITY_ADD_PROXIMITY = 'MAP_SETTINGS_PROXIMITY/ADD_PROXIMITY';
export const MAP_SETTINGS_PROXIMITY_REMOVE_PROXIMITY = 'MAP_SETTINGS_PROXIMITY/REMOVE_PROXIMITY';
export const MAP_SETTINGS_PROXIMITY_SET_HIDE_LABELS = 'MAP_SETTINGS_PROXIMITY/SET_HIDE_LABELS';
export const MAP_SETTINGS_PROXIMITY_SET_HIDE_SMALL_RADII = 'MAP_SETTINGS_PROXIMITY/SET_HIDE_SMALL_RADII';
export const MAP_SETTINGS_PROXIMITY_SET_METRICS = 'MAP_SETTINGS_PROXIMITY/SET_METRICS';
export const MAP_SETTINGS_PROXIMITY_ADD_METRICS = 'MAP_SETTINGS_PROXIMITY/ADD_METRICS';
export const MAP_SETTINGS_PROXIMITY_MODIFY_PROXIMITY = 'MAP_SETTINGS_PROXIMITY/MODIFY_PROXIMITY';
export const MAP_SETTINGS_PROXIMITY_MOVE_INDIVIDUAL_RADIUS = 'MAP_SETTINGS_PROXIMITY/MOVE_INDIVIDUAL_RADIUS';
